import { scroller } from 'react-scroll';
import { StateType, ErrorType } from '../types';
import { FuelSite } from '../types';
import {
  FormContainerActionTypes,
  FormContainerValues,
  FormContainerAction,
} from '../contexts/FormContainerContext';
import { generatePayload } from './analytics.helper';
import { AnalyticTag } from './analytics';

export const getContactNumber = (state: StateType) =>
  state === 'WA' ? '13 13 58' : '13 37 02';

export function getMonthName(month: string) {
  const monthMap: { [key: string]: string } = {
    '01': 'Jan',
    '02': 'Feb',
    '03': 'Mar',
    '04': 'Apr',
    '05': 'May',
    '06': 'Jun',
    '07': 'Jul',
    '08': 'Aug',
    '09': 'Sep',
    '10': 'Oct',
    '11': 'Nov',
    '12': 'Dec',
  };

  return monthMap[month];
}

export function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function scrollToScrollElement(ScrollElementName: string) {
  scroller.scrollTo(ScrollElementName, {
    offset: -10,
    isDynamic: true,
    duration: 250,
    smooth: 'easeInPutQuart',
  });
}

export function getQueryParams(queryString: string) {
  const result: { [key: string]: string } = {};
  const queryParamArray = queryString.substr(1).split('&amp;');
  for (const queryParam of queryParamArray) {
    const item = queryParam.split('=');
    result[item[0]] = decodeURIComponent(item[1]);
  }

  return result;
}

export function deepCopy(object: Record<string, any>) {
  return JSON.parse(JSON.stringify(object));
}

export function setFormContextError(
  formContextValues: FormContainerValues,
  formContextDispatch: (action: FormContainerAction) => void,
  stepIndex: number,
  status: boolean,
  type: ErrorType
) {
  const newContextValue = deepCopy(formContextValues);

  newContextValue.error.steps[stepIndex] = {
    status,
    type,
  };

  formContextDispatch({
    type: 'SET_ERROR' as FormContainerActionTypes,
    value: newContextValue,
  });
}

export function resetFormContextError(
  formContextValues: FormContainerValues,
  formContextDispatch: (action: FormContainerAction) => void,
  stepIndex: number
) {
  const newContextValue = deepCopy(formContextValues);

  newContextValue.error.steps[stepIndex] = {
    status: false,
    type: undefined,
  };

  formContextDispatch({
    type: 'RESET_ERROR' as FormContainerActionTypes,
    value: newContextValue,
  });
}

export function setFormContextBranchDetails(
  formContextValues: FormContainerValues,
  formContextDispatch: (action: FormContainerAction) => void,
  valid: boolean,
  bsbNumber: string,
  displayName: string,
  hideDisplayName: boolean
) {
  const newContextValue = deepCopy(formContextValues);

  newContextValue.bankBranch = {
    valid,
    bsbNumber,
    displayName,
    hideDisplayName,
  };

  formContextDispatch({
    type: 'SET_BRANCH_DETAILS' as FormContainerActionTypes,
    value: newContextValue,
  });
}

export function setFormContextCustomer(
  formContextValues: FormContainerValues,
  formContextDispatch: (action: FormContainerAction) => void,
  customerNumber: string,
  authenticationToken: string,
  fuelSites: FuelSite[]
) {
  const newContextValue = deepCopy(formContextValues);

  newContextValue.customer = {
    customerNumber,
    authenticationToken,
    fuelSites,
  };

  formContextDispatch({
    type: 'SET_CUSTOMER' as FormContainerActionTypes,
    value: newContextValue,
  });
}

export function pushAnalytics(analyticsInfo: AnalyticTag) {
  const analytics = (window as any).dataLayer;
  analytics.push(generatePayload(analyticsInfo));
}
